import MuiCssBaseline, { CssBaselineProps as MuiCssBaselineProps } from '@mui/material/CssBaseline';

export type CssBaselineProps = MuiCssBaselineProps;

export const CssBaseline = (props: CssBaselineProps) => {
  return <MuiCssBaseline {...props} />;
};
